import React from "react";

import { Code, PendingIcon, SuccessIcon, Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import { Link } from "ds/Button";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";

import * as S from "../InitializeWizard.styles";

const ImportYourCode = ({ url }) => {
  const intl = useIntl();

  const environment = useSelectorWithUrlParams(environmentSelector);
  const environmentHasCode = environment?.has_code;

  return (
    <S.Container>
      <S.SubContainer>
        <Typography.Title tag="h3">
          {intl.formatMessage({
            id: "wizard.project.provisioning.importing"
          })}
        </Typography.Title>

        <S.IconLayout>
          {environmentHasCode ? (
            <SuccessIcon color="var(--theme-success-600)" />
          ) : (
            <PendingIcon color="var(--theme-warning-600)" />
          )}
        </S.IconLayout>
        <Typography.BodyText size="small">
          {intl.formatMessage({
            id: "wizard.project.provisioning.repository"
          })}{" "}
          <strong>{environment?.has_code ? "ready" : "empty"}</strong>
        </Typography.BodyText>
        <Typography.BodyText size="small">
          {intl.formatMessage({
            id: "wizard.project.provisioning.further"
          })}
        </Typography.BodyText>
      </S.SubContainer>

      {!environmentHasCode && (
        <S.SubContainerCode>
          <Typography.BodyText size="small">
            {intl.formatMessage<React.ReactNode>(
              {
                id: "wizard.project.provisioning.push.repository"
              },
              {
                strong: chunks => <strong>{chunks}</strong>
              }
            )}
          </Typography.BodyText>

          <Code.Block id="environment-git-cmd" isCopyable singleLine={true}>
            {intl.formatMessage(
              {
                id: "wizard.project.provisioning.remote"
              },
              {
                url
              }
            )}
          </Code.Block>
          <br />

          <Code.Block id="environment-git-cmd" isCopyable singleLine={true}>
            {intl.formatMessage({
              id: "wizard.project.provisioning.push"
            })}
          </Code.Block>

          <Typography.BodyText size="small">
            {intl.formatMessage<React.ReactNode>(
              { id: "wizard.project.provisioning.services" },
              {
                em: txt => <em>{txt}</em>,
                link: chucks => (
                  <Link
                    analyticId="wizard.project.provisioning.link.support.url"
                    variant="link"
                    href={intl.formatMessage({
                      id: "wizard.project.provisioning.link.support.url"
                    })}
                  >
                    {chucks}
                  </Link>
                ),
                code: txt => (
                  <Typography.Code variant="inline">{txt}</Typography.Code>
                )
              }
            )}
          </Typography.BodyText>

          <Typography.BodyText size="small">
            {intl.formatMessage<React.ReactNode>(
              {
                id: "wizard.project.provisioning.adobe.credentials"
              },
              {
                link: chucks => (
                  <Link
                    analyticId="wizard.project.provisioning.link.support.url"
                    variant="link"
                    href={intl.formatMessage({
                      id: "wizard.project.provisioning.link.support.url"
                    })}
                  >
                    {chucks}
                  </Link>
                ),
                code: txt => (
                  <Typography.Code variant="inline">{txt}</Typography.Code>
                )
              }
            )}
          </Typography.BodyText>
        </S.SubContainerCode>
      )}
    </S.Container>
  );
};

export default ImportYourCode;
